// src/services/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://bookingapi.sklogisticsgroup.co.in/', // Change this to your actual backend URL
  headers: {
    'Content-Type': 'application/json'
  }
});

export default api;
